import {Button, Flex, Modal} from 'antd'
import {useNavigate} from 'react-router-dom'
import {useAppContext} from 'common/context/AppContext'
import {SESSION_IS_EXPIRED} from 'common/util/Util'
import { CommonRoutes } from 'common/context/commonRoutes.ts'

export const ErrorModal: React.FC = () => {
    const appContext = useAppContext()
    const navigate = useNavigate()

    return <Modal
        open={appContext.error !== undefined}
        onOk={() => {
            appContext.setError(undefined)
        }}
        closable={false}
        footer={
            <Flex gap="middle" justify="center">
                {
                    appContext.error === SESSION_IS_EXPIRED ?
                        <Button type="primary" onClick={() => {
                            appContext.setError(undefined)
                            navigate(CommonRoutes.LOGIN)
                        }}>
                            Login
                        </Button>
                        :
                        <Button type="primary" onClick={() => {
                            appContext.setError(undefined)
                        }}>
                            OK
                        </Button>
                }
            </Flex>
        }
    >{appContext.error}</Modal>
}